import { createFileRoute, notFound } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { SectionOverviewPage } from '@/features/section-overview/section-overview-page';
import { isSectionId } from '@/features/section-overview/types';

/**
 * A menu section's overview (`/overview/tyres`, `/overview/service-agreement`,
 * `/overview/system`), opened from the section heading.
 *
 * The page itself is core: the endpoint gates each figure on the permission and feature of the
 * list it summarises, and the page shows what it is given.
 */
export const Route = createFileRoute('/_app/overview/$sectionId')({
  staticData: { featureKey: 'section-overview' },
  beforeLoad: async ({ context, location, params }) => {
    if (!isSectionId(params.sectionId)) {
      throw notFound();
    }
    await requireFeature(context, location, { feature: 'section-overview' });
  },
  component: Overview,
});

function Overview() {
  const { sectionId } = Route.useParams();
  // Keyed so a section switch starts from its own loading state, not the previous section's.
  return isSectionId(sectionId) ? (
    <SectionOverviewPage key={sectionId} sectionId={sectionId} />
  ) : null;
}
